"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChineseLogo = require("./ChineseLogo");
Object.keys(_ChineseLogo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChineseLogo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChineseLogo[key];
    }
  });
});
var _CommonLogo = require("./CommonLogo");
Object.keys(_CommonLogo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommonLogo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CommonLogo[key];
    }
  });
});